const info = {}
const base = {
  adminIOS: '2.4.19',
  adminAndroid: '2.2.3',
  saleIOS: '2.7.6',
  saleAndroid: '2.3.3'
}

function getUserAgent() {
  if (!info.serVersion) {
    const u = navigator.userAgent.toLowerCase()
    const android = u.match(/android (.*?);/)
    const iOS = u.match(/os (.*?) like mac os x/)
    const isDuoKe = u.indexOf('duoke') !== -1
    const isWeChat = u.indexOf('micromessenger') !== -1
    const isAli = u.indexOf('aliapp') !== -1
    info.service = !android ? (!iOS ? 'Unknown' : 'IOS') : 'Android'
    info.serVersion = !iOS
      ? !android
        ? '-'
        : android[1]
      : iOS[1].replace(/_/g, '.')
    info.app = isDuoKe ? 'DuoKe' : isWeChat ? 'WeChat' : isAli ? 'Ali' : ''
    if (isDuoKe) {
      info.portType = u.match(/duoke (.*?) v/)[1] || 'Unknown'
      info.portName =
        info.portType === 'admin'
          ? '黑端'
          : info.portType === 'sale'
            ? '红端'
            : '未知设备'
      info.version = u.split(`duoke ${info.portType} v`)[1].split(' ')[0]
    }
  }
  return info
}

function compareVersion(rule, target = base) {
  const user = getUserAgent()
  const key = rule.map((v) => user[v]).join('')
  const real = user.version
  const tar = target[key]
  if (!tar || !real) {
    return false
  }
  const arr = tar.split('.')
  const state = real
    .split('.')
    .reduce(
      (temp, val, i) =>
        temp ||
        (val === arr[i] ? 0 : Number(val || 0) > Number(arr[i] || 0) ? 1 : -1),
      0
    )
  return state !== -1
}

export { getUserAgent, compareVersion }



// WEBPACK FOOTER //
// ./src/utils/nativeInfo.js